import { spaceClient } from './client';

// Game Schedule (the Quiz) — CMS endpoints under /api/space/{spaceId}/cms/quiz (plan section 9.2). The server finds
// the QUIZ game itself, so no call here sends a game id. Reads need membership of the space; writes need
// space_admin or marketing (the controller answers 403 otherwise).

// The space's quizzes, newest first (no paging). Each item carries the approval state (contentStatus,
// approvalStatus, approvalId, approvalActionType, rejectionReason, proposedSnapshot) and `questionCount`,
// but not the questions: use getQuiz for those.
export const getQuizzes = () =>
  spaceClient.get('/cms/quiz').then((r) => r.data);

// One quiz with its questions, options and the correct answers (the CMS is the only place they are shown).
export const getQuiz = (id) =>
  spaceClient.get(`/cms/quiz/${id}`).then((r) => r.data);

// Creates a draft: 201 { quiz }. The body is the save request: { name, scheduleType, referenceDate | startDate+endDate,
// questions }. Build it with buildSavePayload (utils/gameSchedule.js).
export const createQuiz = (payload) =>
  spaceClient.post('/cms/quiz', payload).then((r) => r.data);

// Replaces the whole quiz. 200 { quiz } when a draft was edited directly; 202 { message } when the edit became a
// proposal for approval (a live quiz, or a rejected proposal). `proposed` tells the two apart for the caller.
export const updateQuiz = (id, payload) =>
  spaceClient.put(`/cms/quiz/${id}`, payload).then((r) => ({ ...(r.data ?? {}), proposed: r.status === 202 }));

// 204 when a draft was deleted; 202 { message } when it became a delete proposal.
export const deleteQuiz = (id) =>
  spaceClient.delete(`/cms/quiz/${id}`).then((r) => ({ ...(r.data ?? {}), proposed: r.status === 202 }));

// View Participants: one row per fan per completed attempt of the quiz, ranked inside it. `search` matches the
// username or e-mail; sortDirection 'asc' = top first. Only the parameters that are set are sent.
export const getQuizParticipation = (
  gameScheduleId,
  { search, page = 1, pageSize = 25, sortDirection = 'asc' } = {},
  config = {},
) =>
  spaceClient
    .get('/cms/quiz/participation', {
      ...config,
      params: {
        gameScheduleId,
        page,
        pageSize,
        sortDirection,
        ...(search ? { search } : {}),
      },
    })
    .then((r) => r.data);
